import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourJobOfferEmits = {};
export type TourJobOfferProps = {};

export default class TourJobOfferSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourJobOffer = ref<OrionTour>();

	@Reactive private readonly state = { hasData: false };

	get hasData () { return this.state.hasData }

	constructor (
		private props: TourJobOfferProps,
		private emits: TourJobOfferEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();

		useTour('tourJobOffer', this._tourJobOffer.value);

		this.registerBusEvent('jobOfferLoaded', (val) => {
			this.state.hasData = val;
		});
	}

	orderListHeader () {
		return document.querySelector(`.shared-list-quick-filter`);
	}

}
